import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { TrimesterAccMentorWithAccDetails } from '@interfaces';
import { DomainDataService } from '../../../../../services';
import { AllMentorsGridServiceInterface } from '../all-mentors-grid.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(parent: string, util: UtilityService, domainDataService: DomainDataService, dialogService: DialogService, service: AllMentorsGridServiceInterface): GridSetup<TrimesterAccMentorWithAccDetails> {

	const staffPermissions = service.areaService.staffPermissions();

	return {
		rowName: { singular: 'Mentor', plural: 'Mentors' },
		getRowKey: row => '' + row.accMentorId,
		stateKey: `${parent}-all-mentors-grid`,
		actions: getActions(dialogService, service),
		buttons: [],
		columns: getColumns(util, domainDataService),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${service.areaService.selectedTrimesterName()}-Mentors`
		}
	}
}
